
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundFill as ObiSoundFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-fill.js';
 
 
 

 
 export const ObiSoundFill = createComponent({
   react: React,
   tagName: 'obi-sound-fill',
   elementClass: ObiSoundFillElement,
   events: {
     
   }
  });
 
 